import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import initialState, {
  fulfilledHandler,
  loadingHandler,
  rejectedHandler,
} from "./initialState";
import api from "../api";

export const GetUserDiscountByNimKode = createAsyncThunk(
  "user_discount/GetUserDiscountByNimKode",
  async (data, thunkAPI) => {
    try {
      const response = await axios.get(`${api}master/user_discount/get_by_nim_kode?${data.query}`, {
        headers: {
          Authorization: data.token,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const GetAllUserDiscount = createAsyncThunk(
  "user_discount/GetAllUserDiscount",
  async (data, thunkAPI) => {
    try {
      const response = await axios.get(`${api}master/user_discount/all?${data.url}`, {
        headers: {
          Authorization: data.token,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const GetSingleUserDiscount = createAsyncThunk(
  "user_discount/GetSingleUserDiscount",
  async (data, thunkAPI) => {
    try {
      const response = await axios.get(
        `${api}master/user_discount/get_by_id/${data.id}`,
        {
          headers: {
            Authorization: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const userDiscountSlice = createSlice({
  name: "user_discount",
  initialState,
  reducers: {
    reset: (state) => initialState,
  },
  extraReducers: (builder) => {
    // get user discount by nim dan kode
    builder.addCase(GetUserDiscountByNimKode.pending, loadingHandler);
    builder.addCase(GetUserDiscountByNimKode.fulfilled, fulfilledHandler);
    builder.addCase(GetUserDiscountByNimKode.rejected, rejectedHandler);
    // get all user discount
    builder.addCase(GetAllUserDiscount.pending, loadingHandler);
    builder.addCase(GetAllUserDiscount.fulfilled, fulfilledHandler);
    builder.addCase(GetAllUserDiscount.rejected, rejectedHandler);
    // get Single user discount
    builder.addCase(GetSingleUserDiscount.pending, loadingHandler);
    builder.addCase(GetSingleUserDiscount.fulfilled, fulfilledHandler);
    builder.addCase(GetSingleUserDiscount.rejected, rejectedHandler);
  },
});

export const { reset } = userDiscountSlice.actions;
export default userDiscountSlice.reducer;
